// CacheKey 6f5b6a9fefda97599b1d60588a09790d
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  en: {
    models: {
      attachments: "resources",
      blueprints: "workflow templates",
      care_forms: "care forms",
      care_gram: "care gram",
      care_grams: "care grams",
      care_referral: "care referral",
      care_referrals: "care referrals",
      Care_Referral: "Care Referral",
      Care_Referrals: "Care Referrals",
      CareGram: "Care Gram",
      CareGrams: "Care Grams",
      care_management_enrollment: "Care Management Enrollment",
      care_management_enrollments: "Care Management Enrollments",
      CareManagementEnrollment: "Care Management Enrollment",
      care_team: "care team",
      CareTeam: "Care Team",
      comment: "care note",
      Comment: "Care Note",
      comments: "care notes",
      Comments: "Care Notes",
      community_resource: "Community Resource",
      community_resources: "Community Resources",
      diagnosis: "diagnosis",
      Diagnosis: "Diagnosis",
      diagnoses: "diagnoses",
      Diagnoses: "Diagnoses",
      encounter: "encounter",
      Encounter: "Encounter",
      encounters: "encounters",
      Encounters: "Encounters",
      enrollment: "enrollment",
      enrollments: "enrollments",
      external_visit: "External Visit",
      external_visits: "External Visits",
      floorplans: "floorplans",
      goals: "goals",
      Goal_Task: "Goal Task",
      key_metric: "key metric",
      key_metrics: "key metrics",
      medication: "medication",
      Medication: "Medication",
      medications: "medications",
      Medications: "Medications",
      observation: "observation",
      Observation: "Observation",
      observations: "observations",
      Observations: "Observations",
      observation_result: "observation result",
      observation_results: "observation results",
      patient: "patient",
      Patient: "Patient",
      patients: "patients",
      Patients: "Patients",
      patient_list_config: "patient list config",
      patient_list_configs: "patient list configs",
      referral: "referral",
      Referral: "Referral",
      referrals: "referrals",
      Referrals: "Referrals",
      SurveyDevices: "Kiosk Devices",
      SurveyLocations: "Kiosk Locations",
      workflow: "workflow",
      Workflow: "Workflow",
      workflows: "workflows",
      Workflows: "Workflows",
      report_package: "report package",
      report_package_event: "report package event",
      report_package_events: "report package events",
      report_packages: "report packages",
      task: "task",
      Task: "Task",
      tasks: "tasks",
      Tasks: "Tasks",
      unit: "unit",
      Unit: "Unit",
      units: "units",
      Units: "Units"
    },
    exports: {
      defaults: {
        care_management_enrollment: {
          date_of_enrollment: "Enrolled At"
        },
        care_team: {
          team_members: "Care Team"
        },
        encounter: {
          id: "Encounter ID",
          mrn: "MRN",
          status: "Encounter Status"
        },
        interaction: {
          id: "Interaction ID",
          interaction_time: "Call Time"
        },
        key_metric: {
          id: "Key Metric ID",
          pam_level: "PAM Level",
          pam_score: "PAM Score"
        },
        patient: {
          id: "Patient ID",
          name: "Patient Name",
          patient_list_priority: "Priority"
        },
        task: {
          id: "Task ID",
          name: "Task Name",
          team_member: "Assigned To"
        },
        unit: {
          group: "Unit Group",
          name: "Unit Name",
          type: "Unit Type"
        },
        workflow: {
          id: "Workflow ID",
          name: "Workflow Name",
          status: "Workflow Status"
        }
      }
    },
    admitted_patients: {
      title: "Admitted Patients"
    },
    pathway_patients: {
      title: "Pathway Patients"
    },
    agenda: {
      info: "All tasks assigned to you that are overdue or due in the next 6 days.",
      loading: "Loading {{user}} upcoming tasks…"
    },
    archived_audio_instructions_search: {
      nav_menu: "Archived Care Recordings"
    },
    attachments: {
      title: "Resources"
    },
    outreach_blockages_search: {
      nav_menu: "Outreach Blockages"
    },
    audio_instructions_search: {
      nav_menu: "Care Recordings"
    },
    care_form_configs: {
      title: "Care Form Configs"
    },
    care_forms: {
      title: "Care Forms"
    },
    care_management_enrollments_search: {
      nav_menu: "Care Management Enrollments"
    },
    diagnoses: {
      title: "Diagnoses",
      icd_code_version: "ICD Code Version"
    },
    encounter: {
      mrn: "MRN"
    },
    goals: {
      title: "Goals"
    },
    medications: {
      title: "Medications"
    },
    patient: {
      captain: "Captain",
      date_of_birth: "Date of Birth",
      date_of_enrollment: "Date of Enrollment",
      first_name: "First Name",
      gender: "Gender",
      key_metrics: "Key Metrics",
      last_name: "Last Name"
    },
    patient_list: {
      title: "Patient List"
    },
    patient_list_configs: {
      title: "Patient List Configs"
    },
    patients: {
      title: "Patients"
    },
    workflow_exports: {
      title: "Workflow Exports"
    },
    workflow: {
      title: "Workflow"
    },
    closed_tasks: {
      nav: "Closed Tasks",
      title: "Recently Closed Tasks",
      pending_tasks: "Go to My Pending Tasks"
    },
    encounters: {
      arrival: "Arrival",
      diagnosis: "Diagnosis"
    },
    interactions_search: {
      my_interactions: "My Rounds"
    },
    monitored_patients: {
      title: "Monitored Patients"
    },
    my_patient_panel: {
      title: "My Patient Panel"
    },
    observations_search: {
      nav_menu: "Observations"
    },
    observation_results_search: {
      nav_menu: "Observation Results"
    },
    pending_tasks: {
      title: "My Pending Tasks",
      info: "Upcoming tasks assigned to you.",
      closed_tasks: "Go to Recently Closed Tasks",
      tasks_search: "Tasks Search"
    },
    patient_rounding_assignments: {
      title: "Patient Rounding Assignments"
    },
    patients_search: {
      nav_menu: "Patients"
    },
    patient_tasks: {
      title: "Tasks",
      add_task: "Add Task"
    },
    plans: {
      patient_information: "Patient Info"
    },
    care_referrals: {
      title: "Care Referrals"
    },
    referrals_search: {
      nav_menu: "Referrals"
    },
    rounding: {
      answer_details: {
        placeholder: "Details…"
      },
      free_text_response: "Please enter response here",
      care_note_text_response: "Enter your comments here",
      caregram: {
        message: "Please enter response here"
      },
      contact_information: {
        name: "Name",
        email: "Email",
        phone: "Phone"
      },
      details_question: {
        disabled: "Please select answer above…",
        response: "Your answer…"
      },
      round_summary: {
        message: "Please enter message here"
      }
    },
    rounding_scripts: {
      details_question_body: "Would you like to add any additional information?"
    },
    staff_rounding: {
      nav_menu: "Staff Members"
    },
    staff_rounding_assignments: {
      nav_menu: "Staff Rounding Assignments"
    },
    tasks: {
      assignment_not_available: "Reassignment is not available in this view."
    },
    tasks_export: {
      nav: "Tasks Export",
      title: "Tasks Export"
    },
    tasks_search: {
      nav: "All Tasks",
      title: "Tasks Search"
    },
    employee_engagement: {
      title: "Employees"
    },
    webform: {
      question_header: "Your health matters to us."
    }
  }
}

